import React from 'react';
import { FC } from 'react';
import {Link} from 'gatsby';
import { motion, AnimatePresence } from 'motion/react';
import {menuenterleft, navbackground, navborderitems, navitem, navlist} from './animations';
import { listitem, liststyle, navigationBottomContainer, navlink, navmenu, overlay } from './styles';
import settings from '@settings';
import LinkElement from './components/LinkElement';
import { NavigationProps } from './types';

const Navigation: FC<NavigationProps> = ({showMenu, setShowMenu}) => {
	return (
		<AnimatePresence mode='sync'> 
			{showMenu && 
				<>
					<motion.div
						key="navbackground"
						variants={navbackground}
						initial="initial"
						animate="animate"
						exit="exit"
						css={overlay}
						onClick={() => setShowMenu(false)}
					/>
					<motion.div 
						key="345" 
						css={navmenu} 
						initial="initial"
						animate="visible"
						exit="hidden"
						variants={menuenterleft}
					>
						
						<motion.div
							css={liststyle}
							variants={navlist}
							initial="initial"
							animate="visible"
							exit="hidden"
						> 
							<motion.li variants={navitem} css={listitem} key="23244">
								<LinkElement 
									name={'patwork'} 
									setShowMenu={setShowMenu} 
									link={'/'} 
									number={'01'} 
								/>
							</motion.li>
							<motion.li variants={navitem} css={listitem} key="46738">
								<LinkElement name={'Projekte'} setShowMenu={setShowMenu} link='/projekte' number={'02'} />
							</motion.li>
							<motion.li variants={navitem} css={listitem} key="42378">
								<LinkElement name={'Fokus'} setShowMenu={setShowMenu} link='/focus' number={'03'} />
							</motion.li>
							<motion.li variants={navitem} css={listitem} key="42378">
								<LinkElement 
									name={'Kontakt'} 
									setShowMenu={setShowMenu} 
									link='/kontakt' 
									number={'04'} 
								/>
							</motion.li>
						</motion.div>
						<motion.div
							variants={navborderitems}
							initial="initial"
							animate="animate"
							exit="exit"
							key="48768"
							css={{height: 'auto', width: '100%'}}
						>
							<div css={navigationBottomContainer}>
								<Link
									css={navlink}
									onClick={() => setShowMenu(false)}
									to="/impressum"
									activeStyle={{color: settings.colors.primary}}
								> Impressum</Link>
								<Link
									css={navlink}
									onClick={() => setShowMenu(false)}
									to="/datenschutz"
									activeStyle={{color: settings.colors.primary, borderBottom: '1px solid ' + settings.colors.primary}}
								> Datenschutz</Link>
								<Link
									css={navlink}
									onClick={() => setShowMenu(false)}
									to="/agb"
									activeStyle={{color: settings.colors.primary, borderBottom: '1px solid ' + settings.colors.primary}}
								> AGB</Link>
							</div>
						</motion.div>
					</motion.div>
				</>
			}
		</AnimatePresence>
	);
};

export default Navigation;